import React, { useEffect } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { AppContext } from "../../contexts/AppContext";
import { useNavigate } from "react-router-dom";
import { updateApplication } from "../../Services/applicationService";

const PreReferee = ({ handleNext, handleCancel, handleBack }) => {
  const { appState, setAppState, userFlows, setUserFlows } =
    React.useContext(AppContext);
  const navigate = useNavigate();

  const handleNoReferee = () => {
    setUserFlows({
      ...userFlows,
      noPhotoId: false,
      refereeNotAvailable: true,
    });
    navigate("/app/photo-id");
  };

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const updatedPayload = {
          ...appState?.requestPayload,
          hasRefereeData: false,
        };

        try {
          await updateApplication(updatedPayload);
        } catch (err) {
          console.error("Failed to update application with liveness", err);
        }

        if (cancelled) return;

        setAppState((prev) => ({
          ...prev,
          requestPayload: updatedPayload,
        }));
      } catch (err) {
        console.error("Failed to update application with liveness", err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <div className="intro">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Whakaratoa he kaitautoko tuakiri, hei whakaū i ō taipitopito
        </h1>
        <hr />
        <h1 className="intro-title">
          Provide an identity referee to confirm your details
        </h1>

        <div className="step-container">
          <p className="mb-4">
            We need you to provide a referee who can confirm that you are who
            you say you are.
          </p>
          <h2 className="mb-16 text-24">The referee must:</h2>
          <ul className="step-listing">
            <li className="step-item">be aged 16 or over</li>
            <li className="step-item">
              have a current or expired New Zealand passport
            </li>
            <li className="step-item">
              have known the applicant for at least 1 year
            </li>
            <li className="step-item">
              be able to complete an online identity check
            </li>
            <li className="step-item">
              agree to be your referee (we may contact them)
            </li>
            <li className="step-item">
              be available if we call or email them to verify details about your
              application — this will help avoid delays.
            </li>
          </ul>
          <h2 className="mb-16 text-24">The referee cannot:</h2>
          <ul className="step-listing">
            <li className="step-item">
              be related to you or part of your extended family (this includes
              spouses and partners)
            </li>
            <li className="step-item">live at the same address as you.</li>
          </ul>
          <h2 className="mb-16 text-24">You need the referee's:</h2>
          <ul className="step-listing">
            <li className="step-item">
              current or expired New Zealand passport number
            </li>
            <li className="step-item">full name</li>
            <li className="step-item">mobile number</li>
            <li className="step-item">date of birth</li>
            <li className="step-item">email address</li>
            <li className="step-item">home address</li>
          </ul>
        </div>
      </div>

      <div className="step-button-container">
        <SubmitButton text={"Continue"} onClick={handleNext} />
      </div>
      <div className="checkbox-wrapper mb-5">
        <label className="terms-label">
          If you do not know anyone who can be a referee, you can{" "}
          <a href="#" className="cancel-link" onClick={handleNoReferee}>
            complete your <br /> application in person at a RealMe partner
            store.
          </a>
        </label>
      </div>
    </>
  );
};

export default PreReferee;
